<template>
  <div>
    <b-row class="d-flex justify-content-center btn-lang">
      <div>
        <b-button
          variant="outline-primary"
          :class="{ active: isAr() }"
          @click="getAr"
          >عربي</b-button
        >
        <b-button
          variant="outline-primary"
          class="m-1"
          :class="{ active: isEn() }"
          @click="getEn"
          >إنكليزي</b-button
        >
        <b-button
          variant="outline-primary"
          :class="{ active: isKr() }"
          @click="getKr"
          >كوردي</b-button
        >
      </div>
    </b-row>
    <b-row>
      <b-col cols="12" lg="3" md="6">
        <b-card class="Menu" v-b-modal.modal-1>
          <ValidationObserver ref="form">
            <b-modal @ok="addImg" id="modal-1" title="إضافة صورة جديدة">
              <ek-input-select
                :options="langOptions"
                v-model="menuDto.language"
                name=" lang"
                placeholder="اختر اللغة  "
                label=" إضافة إلى القائمة ذات اللغة"
                :rules="[
                  {
                    type: 'required',
                    message: 'وحدة الدرس مطلوبة',
                  },
                ]"
              ></ek-input-select>
              <ek-input-image @input="getFile">
                <h5>اسحب الملف او انقر للتحميل</h5>
              </ek-input-image>
            </b-modal>
          </ValidationObserver>
          <div
            class="d-flex justify-content-center flex-column w-100"
            style="align-items: center"
          >
            <unicon name="image-plus" fill="#007565" height="25px"></unicon>
            <h4 class="pt-2">قم بإضافة صورة جديدة</h4>
          </div>
        </b-card>
      </b-col>
      <!-- <draggable v-model="paginationList"> -->
      <b-col cols="12" lg="3" md="6" v-for="item in menues" :key="item.id">
        <b-card v-viewer>
          <template #header class="card-header">
            <div
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div ref="order" class="ml-2" style="width: 50px">
                <ek-input-text
                  :value="item.order"
                  @change="changeOrder($event, item.id)"
                  type="number"
                  name="order"
                ></ek-input-text>
              </div>
              <div>
                <b-dropdown
                  size="md"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template #button-content class="p-0 pb-1">
                    <unicon name="ellipsis-v" class="button"></unicon>
                  </template>
                  <b-dropdown-item @click="delImg(item.id)" class="svg-class">
                    <span>حذف</span>
                    <unicon class="ml-2" name="trash" fill="#007565"></unicon>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </template>
          <b-img
            :src="$store.getters['app/domainHost'] + '/' + item.url"
            class="MenuImg"
          ></b-img>
        </b-card>
      </b-col>
      <!-- </draggable> -->
    </b-row>
  </div>
</template>


<script>
import { mapState, mapActions, mapMutations } from "vuex";
// import draggable from "vuedraggable";
import VueViewer from "v-viewer";
import Vue from "vue";
Vue.use(VueViewer);

export default {
  components: {
    // draggable,
  },
  data() {
    return {
      active_el: 0,
    };
  },
  computed: {
    ...mapState({
      menues: (state) => state.home.menues,
      menuDto: (state) => state.home.menuDto,
      langOptions: (state) => state.home.langOptions,
      changeOrderDto: (state) => state.home.changeOrderDto,
    }),
  },
  methods: {
    ...mapActions([
      "getAllMenu",
      "addMenu",
      "getAllMenuAr",
      "getAllMenuEn",
      "getAllMenuKr",
      "deleteImg",
      "changeOrder",
    ]),
    ...mapMutations(["Reset_Order_Dto"]),
    addImg() {
      this.$refs.form.validate().then((succ) => {
        if (succ) {
          this.addMenu(this.menuDto);
          this.active_el = this.menuDto.language;
          this.$refs.form.reset();
        }
      });
    },
    changeOrder(event, id) {
      this.changeOrderDto.id = id;
      this.changeOrderDto.language = +this.active_el;
      this.changeOrderDto.newOrder = +event;
      this.$store.dispatch("changeOrder", this.changeOrderDto);
      this.$store.commit("Reset_Order_Dto");
    },
    delImg(id) {
      this.deleteImg(id);
    },
    getFile($event) {
      this.menuDto.files = $event.file;
    },
    isAr() {
      return this.active_el == 1;
    },
    isEn() {
      return this.active_el == 2;
    },
    isKr() {
      return this.active_el == 3;
    },
    getAr() {
      this.active_el = 1;
      this.getAllMenuAr();
    },
    getEn() {
      this.active_el = 2;
      this.getAllMenuEn();
    },
    getKr() {
      this.active_el = 3;
      this.getAllMenuKr();
    },
  },
};
</script>
<style lang="scss" scoped>
.Menu {
  cursor: pointer;
  height: 370px;
}
.MenuImg {
  width: 100%;
  height: 300px;
}
.card-body {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}
.btn-lang {
  position: relative;
  bottom: 44px;
}
.card .card-header {
  display: contents;
}

@media (max-width: 766px) {
  .btn-lang {
    position: relative;
    bottom: 6px;
  }
}
</style>